import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import { setSliceImageEnhancerDataAction } from '../../../../redux/slices/FJSliceImageManipulation';
import PropTypes from 'prop-types';
import FJImageEnhancerCard from '../view/FJImageEnhancerCard';

const FJImageEnhancerCardContainer = props => {
    const { disabled, style } = props;
    useLocalStore();
    const dispatch = useDispatch();
    const imageEnhancerData = useSelector(state => state.imageManipulation.imageEnhancerData);
    const uploadImageInfo = useSelector(state => state.imageManipulation.uploadImageInfo);
    const { switch: active, upscale, imageType } = imageEnhancerData;

    const _onSwitch = value => {
        dispatch(setSliceImageEnhancerDataAction({ ...imageEnhancerData, switch: value }));
    };
    const _onChangeZoom = value => {
        dispatch(setSliceImageEnhancerDataAction({ ...imageEnhancerData, upscale: value }));
    };
    const _onChangeImageType = value => {
        dispatch(setSliceImageEnhancerDataAction({ ...imageEnhancerData, imageType: value }));
    };

    return (
        <FJImageEnhancerCard
            imageEnhancerData={imageEnhancerData}
            uploadImageInfo={uploadImageInfo}
            onSwitch={_onSwitch}
            onChangeZoom={_onChangeZoom}
            active={active}
            upscale={upscale}
            onChangeImageType={_onChangeImageType}
            imageType={imageType}
            disabled={disabled}
            style={style}
        />
    );
};

FJImageEnhancerCardContainer.propTypes = {
    disabled: PropTypes.bool,
    style: PropTypes.object,
};

export default FJImageEnhancerCardContainer;
